

















































































































import { Component, Mixins } from "vue-property-decorator";
import RedStar from "@/components/ui/RedStar.vue";
import Stepper from "@/components/ui/Stepper.vue";
import { RequestIdValidatorMixin } from "@/mixins/RequestIdValidatorMixin";
import PhoneMask from "@/components/ui/PhoneMask.vue";
import { RequestsModule } from "@/store/requests.module";
import { translate } from "@/utils";
import { Attachment } from "~/attanchment";
import { FileService } from "@/services/file.service";
import EDSDialog from "@/components/ui/EDSDialog.vue";
import { SignService } from "@/services/sign.service";
import { AuthModule } from "@/store/auth.module";
import { BaseModule } from "@/store/base.module";
import { ParamData } from "../../lib/param.data";
import { NCALayerModes } from "@/config/consts";
import { ReportsModule } from "@/store/reports.module";

@Component({
  components: { RedStar, Stepper, PhoneMask, EDSDialog },
})
export default class RequestView extends Mixins(RequestIdValidatorMixin) {
  RequestRid: number = null as any;
  paramData: ParamData = new ParamData();
  ChildLiveCount: number = 0;
  $refs: {
    edsDialogRef: EDSDialog;
  };

  getAttach_type_name(item: Attachment) {
    const res = translate(item);
    return (res as any).attach_type_name;
  }

  get listAttachment() {
    return RequestsModule.listAttachment;
  }
  set listAttachment(val) {
    RequestsModule.setListAttachment(val);
  }

  async mounted() {
    RequestsModule.setlistAttachment();
    await this.validateRequestId();
    this.RequestRid = Number(this.$route.params.id);
    if (this.RequestRid) {
      await RequestsModule.getAttachments(this.RequestRid);
    } else this.$router.push("/requests");
  }

  async showFile(item: Attachment) {
    await RequestsModule.getFile(item.attach_id).then(res => {
      const byteOffset = 0;
      const b = new Blob([
        new Uint8Array(res.attach_file.data, byteOffset, length),
      ]);
      FileService.downloadFile(b, item.attach_file_name);
    });
  }

  clickFile(index: number) {
    const x = (this.$refs as any)["file_" + index] as any;
    if (x) {
      if (Array.isArray(x)) x[0].$refs.input.click();
      else x.$refs.input.click();
    }
  }

  async deleteFile(item: Attachment) {
    try {
      item.loading = true;
      await RequestsModule.deleteAttachment(item.attach_id);
      await RequestsModule.getAttachments(this.RequestRid);
    } finally {
      item.loading = false;
    }
  }

  async fileChange(item: Attachment) {
    try {
      item.loading2 = true;
      if (item.fileData) {
        const f = item.fileData;
        //проверим файл на размер
        const ext = f.name
          .substring(f.name.lastIndexOf(".") + 1, f.name.length)
          .toLowerCase();
        const exts = ["png", "jpg", "jpeg", "gif", "pdf"];
        if (exts.indexOf(ext) < 0) {
          RequestsModule.setError({
            attatchment_type_rid: item.attatchment_type_rid,
            err: 1,
          });
          return;
        }
        if (f.size > 28 * 1024 * 1024) {
          RequestsModule.setError({
            attatchment_type_rid: item.attatchment_type_rid,
            err: 2,
          });
          return;
        }
        const formData = new FormData();
        formData.append("file", item.fileData);
        await RequestsModule.uploadFile({
          attatchment_type_rid: item.attatchment_type_rid,
          RID: Number.parseInt(this.$route.params.id),
          data: formData,
        }).then(() => {
          RequestsModule.getAttachments(this.RequestRid);
        });
      }
    } finally {
      item.loading2 = false;
    }
  }

  checkFiles() {
    let count: number = 0;
    const child_count: number = this.listAttachment.filter(
      c => c.code_name === "at_Свидетельство о рождении ребенка",
    ).length;
    this.listAttachment.forEach(item => {
      if (item.is_required && !item.attach_file_name) {
        item.isError = 3;
        count++;
      } else if (
        item.code_name === "at_Свидетельство о рождении ребенка" &&
        child_count != item.child_live_count
      ) {
        item.isError = 4;
        count++;
      } else {
        item.isError = null as any;
      }
    });
    return count;
  }

  async signAndSend() {
    if (this.checkFiles() > 0) return;
    BaseModule.setLoadingStatus(true);
    await RequestsModule.getData(this.RequestRid);
    await RequestsModule.getAttachments(this.RequestRid);
    await this.sign();
    BaseModule.setLoadingStatus(false);
  }

  get user() {
    return AuthModule.user;
  }

  getParam(code_name: string): any {
    return RequestsModule.reqDetailList.find(
      item => item.code_name === code_name,
    )?.param_value;
  }

  async sign() {
    const signData = await ReportsModule.getDocForSign(this.RequestRid);

    const signResult = await this.$refs.edsDialogRef.sign(signData, {
      signKey: "SIGNATURE",
      signMethod: NCALayerModes.base64,
      signDocumentName: {
        id: 1,
        nameEn: "Application",
        nameRu: "Заявление",
        nameKz: "Өтініш",
      },
      validate: true,
    });
    if (!signResult) {
      //this.$refs.ecpSingerRef.closeWindow();
      return;
    }

    //const parsedJSON = await xml2js.parseStringPromise(signResult);
    // Проверка на отозванность и прочее
    const {
      result: v_result,
      message: v_message,
    } = await SignService.validateEDS(
      signResult as string,
      "SIGNATURE",
      this.user?.first_boss_iin,
    );

    if (!v_result) {
      return BaseModule.showMessage({
        message: translate(v_message as ApiMessageObject).name as string,
        color: "error",
      });
    } else {
      const base64Response = await fetch(
        `data:application/pdf;base64,${signResult}`,
      );
      const blob = await base64Response.blob();

      const formData = new FormData();
      formData.append("file", blob);
      await RequestsModule.signAndSend({
        RID: this.RequestRid,
        data: formData,
      });
      this.$router.push("/");
    }
  }

  get isNewOrEdit() {
    //only on two statuses check inputed data and save else goto attachments
    const cur = RequestsModule.list.find(x => x.record_id == this.RequestRid);
    const cur_state = cur && cur.code_name ? cur.code_name : "";
    return cur_state == "state_draft" || cur_state == "state_returned";
  }
}
